import ArchonLayout, {
  Background,
  Container,
} from '../../layouts/ArchonLayout/ArchonLayout';
import Seo from '../Seo/Seo';
import React, { type JSX } from 'react';
import { type ArchonHeaderViewModel } from '../ArchonHeader/ArchonHeader';
import { type ArchonFooterViewModel } from '../ArchonFooter/ArchonFooter';
import { type AboutPageViewModel } from '../../helpers/getAboutPageViewModels';
import ArchonTitle from '../ArchonTitle/ArchonTitle';
import EnhancedMarkdown from '../../../resources/js/components/EnhancedMarkdown/EnhancedMarkdown';
import enhancedMarkdownOverrides from '../../helpers/enhancedMarkdownOverrides';
import {
  type ViewModels,
  ViewModelsProvider,
} from '../../contexts/useViewModels';
import VerticalContent from '../../../resources/js/components/VerticalContent/VerticalContent';
import StaffGrid from '../StaffGrid/StaffGrid';

type AboutPageProps = {
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
  page: AboutPageViewModel;
  viewModels: ViewModels;
};

export default function AboutPage({
  header,
  footer,
  page,
  viewModels,
}: AboutPageProps): JSX.Element {
  const { seo, heading, body, staffAvatars } = page;

  return (
    <ViewModelsProvider value={viewModels}>
      <ArchonLayout header={header} footer={footer}>
        <Seo {...seo} />
        <Background />
        <Container>
          <ArchonTitle heading={heading} />
          <VerticalContent gap={'xlarge'}>
            <EnhancedMarkdown
              markdown={body}
              overrides={enhancedMarkdownOverrides}
            />
            <StaffGrid staff={staffAvatars} />
          </VerticalContent>
        </Container>
      </ArchonLayout>
    </ViewModelsProvider>
  );
}
